//
// Copyright 2025 DXOS.org
//

import { Atom } from '@effect-atom/atom';

import { type MulticastObservable } from '@dxos/async';

const observableFamily = Atom.family((observable: MulticastObservable<any>) => {
  return Atom.make((get) => {
    const subscription = observable.subscribe((value) => get.setSelf(value));

    get.addFinalizer(() => subscription.unsubscribe());

    return observable.get();
  });
});

/**
 * Creates an Atom.Atom<T> from a MulticastObservable<T>
 * Will return the same atom instance for the same observable.
 */
export const fromObservable = <T>(observable: MulticastObservable<T>): Atom.Atom<T> => {
  return observableFamily(observable) as Atom.Atom<T>;
};
